var map = {
	"./bn-BD/iview.json": [
		"402b",
		"lang-iview-bn-BD-iview-json"
	],
	"./fil-PH/iview.json": [
		"fb01",
		"lang-iview-fil-PH-iview-json"
	],
	"./km-KH/iview.json": [
		"81c7",
		"lang-iview-km-KH-iview-json"
	],
	"./ms-MY/iview.json": [
		"22ec",
		"lang-iview-ms-MY-iview-json"
	],
	"./my-MM/iview.json": [
		"9720",
		"lang-iview-my-MM-iview-json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "abe7";
module.exports = webpackAsyncContext;